module.exports = __webpack_public_path__ + "img/ibestica.726e6cc4.svg";